// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import App from '@/App.vue'
import router from '@/router'
import BootstrapVue from 'bootstrap-vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
// import colors from 'vuetify/es5/util/colors'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueDragDrop from 'vue-drag-drop'
import ToggleButton from 'vue-js-toggle-button'
import TreeView from 'vue-json-tree-view'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import VueCookies from 'vue-cookies'
import store from '@/store/store.js'
import VueMoment from 'vue-moment'
import VueShortkey from 'vue-shortkey'
import Clipboard from 'v-clipboard'
import lineClamp from 'vue-line-clamp'
import VueApexCharts from 'vue-apexcharts'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

// Custom Plugins
import '@/plugins/filters.js'
import CONSTANTS from '@/plugins/const.js'
import commons from '@/plugins/commons.js'
import time from '@/plugins/time.js'
import timecode from '@/plugins/timecode.js'
import paths from '@/plugins/paths.js'
import weight from '@/plugins/weight.js'
import user from '@/plugins/user.js'
import colors from '@/plugins/colors.js'
import ffprobe from '@/plugins/ffprobe.js'
import maestro from '@/plugins/maestro.js'
import navigation from '@/plugins/navigation.js'
import grv_clipboard from '@/plugins/clipboard.js'
import ApiPlayer from '@/services/api_player.js'
import FileOpener from '@/services/fileopener.js'
import MaestroApi from '@/api/maestro_api.js'
import MaestroEs from '@/api/maestro_es.js'
import AcmeApi from '@/api/acme_api.js'
import NexusApi from '@/api/nexus_api.js'
import PublicApi from '@/api/public_api.js'
import Sanitize from '@/plugins/sanitize.js'
import SafeHtmlPlugin from '@/directives/safeHtml'
import { PDMS, OP_ZONES, PROJECTS, CATEGORIES } from '@/constants.js'

import config from '../config/runtime_config.js'
const { configs_map: maestroConfigsMap } = require('../config/maestro_config.js')

// Expose config globally for app access (config has hashed keys, app-loader rewrites accesses)
window.appConfig = config

// Select the right maestro_wf config based on NODE_ENV
// const maestro_wf = maestroConfigsMap[window.appConfig._$ppt9qr] || maestroConfigsMap.development
const maestro_wf = maestroConfigsMap[process.env.ENV_URLS] || maestroConfigsMap.development
window.appConfig.maestro_wf = maestro_wf

library.add(fas, fab, far)

window.Vue = Vue

if (window.appConfig._$ppt9qr === 'development') {
	window.appConfig._$92sql3 = 'http://localhost:8888'
}

const sentryEnvironments = ['production', 'staging']
if (sentryEnvironments.indexOf(window.appConfig._$ppt9qr) > -1) {
	Sentry.init({
		Vue: Vue,
		dsn: 'https://7a496301e9724bcea7279b1d89782051@o69541.ingest.sentry.io/5265841',
		environment: window.appConfig._$ppt9qr,
		release: window.appConfig._$gzluk8,
		integrations: [new Integrations.BrowserTracing()],
		tracesSampleRate: 0.2,
		ignoreErrors: [
			'ResizeObserver loop limit exceeded',
			'ResizeObserver loop completed with undelivered notifications',
			'Non-Error exception captured'
		],
		tracingOptions: {
			trackComponents: true
		}
	})
}

const eventDialer = {
	install (Vue, options) {
		Vue.prototype.$EventDialer = (status, loading, title, message, timeout) => {
			Vue.prototype.$Bus.$Bus.$emit('event_dial', {
				status: status,
				loading: loading,
				title: title,
				message: message,
				timeout: timeout
			})
		}
	}
}

const toaster = {
	install (Vue, options) {
		Vue.prototype.$Toaster = (payload) => {
			let uuid = payload.id
			if (!uuid) {
				uuid = window.vm.$commons.uuid()
				payload.id = uuid
			}
			Vue.prototype.$Bus.$Bus.$emit('toaster', payload)
			return uuid
		}
	}
}

// Custom plugins use
Vue.use(VueCompositionApi)
Vue.use(commons)
Vue.use(time)
Vue.use(timecode)
Vue.use(paths)
Vue.use(weight)
Vue.use(user, {store: store, constants: CONSTANTS})
Vue.use(colors)
Vue.use(ffprobe)
Vue.use(maestro)
Vue.use(navigation, {router: router})
Vue.use(grv_clipboard)
Vue.use(ApiPlayer)
Vue.use(FileOpener)
Vue.use(VueShortkey, { prevent: ['input', 'textarea'] })
Vue.use(MaestroApi)
Vue.use(MaestroEs)
Vue.use(AcmeApi)
Vue.use(NexusApi)
Vue.use(PublicApi)
Vue.use(eventDialer)
Vue.use(toaster)
Vue.use(Sanitize)
Vue.use(SafeHtmlPlugin)

// NPM plugins

Vue.use(BootstrapVue)
Vue.use(Vuetify, {
	options: {
		customProperties: true
	}
})
Vue.use(VueDragDrop)
Vue.use(TreeView)
Vue.use(VueCookies)
Vue.use(VueMoment)
Vue.use(CONSTANTS)
Vue.use(ToggleButton)
Vue.use(Clipboard)
Vue.use(lineClamp)
Vue.use(VueApexCharts)

// NPM Components
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.component('apexchart', VueApexCharts)
Vue.config.productionTip = window.appConfig._$ppt9qr

// export const eventBus = new Vue()
Vue.prototype.$Bus = new Vue() // Global event bus
Vue.prototype.$Pdms = PDMS
Vue.prototype.$OpZones = OP_ZONES
Vue.prototype.$Projects = PROJECTS
Vue.prototype.$SupportCats = CATEGORIES
Vue.prototype.$PgmContents = require('../scripts/pgm_contents.json')
Vue.prototype.$PgmDefects = require('../scripts/pgm_defects.json')

let operatingSystem = ''
let userAgent = navigator.userAgent
if (userAgent.search('Windows') !== -1) {
	operatingSystem = 'Windows'
} else if (userAgent.search('Mac') !== -1) {
	operatingSystem = 'MacOS'
} else if (userAgent.search('X11') !== -1 && !(userAgent.search('Linux') !== -1)) {
	operatingSystem = 'UNIX'
} else if (userAgent.search('X11') !== -1 && userAgent.search('Linux') !== -1) {
	operatingSystem = 'Linux'
}
Vue.prototype.$OS = operatingSystem

/* eslint-disable no-new */
window.vm = new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js